import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Live count of what the model really receives (your text + hidden app instructions) vs. its character limit.
export default function usePromptBudget(body) {
  const [b, setB] = useState(null);
  const key = body ? JSON.stringify(body) : "";
  useEffect(() => {
    if (!key) { setB(null); return undefined; }
    const t = setTimeout(() => api.post("/prompt/budget", JSON.parse(key)).then((r) => setB(r.data)).catch(() => setB(null)), 350);
    return () => clearTimeout(t);
  }, [key]);
  return b;
}
